import { useQuery } from 'react-query';
import { getBillingSubscriptions } from '../api/getBillingSubscriptions';

const useBillingSubscriptions = (user_id) => {
  if (!user_id) {
    return false;
  }
  const result = useQuery('billingSubscriptions', () => getBillingSubscriptions(), {
    refetchOnWindowFocus: false,
    staleTime: 50000,
  });
  return result;
};

export default useBillingSubscriptions;
